export const getBmi = ({
  height,
  heightUnit,
  weight,
  weightUnit,
}: {
  height: number
  heightUnit?: string
  weight: number
  weightUnit?: string
}): number | null => {
  if (!height || !weight) return null
  if (heightUnit === 'cm') {
    height = height / 2.54
  }
  if (weightUnit === 'kg') {
    weight = weight / 2.20462
  }
  return parseFloat(((weight / (height * height)) * 703).toFixed(1))
}

export const diagnosesByBmi = ({ bmi }: { bmi: number }) => {
  if (!bmi) return []

  if (bmi >= 70) {
    return ['Z68.45', 'E66.813'] // BMI 70 or greater
  } else if (bmi >= 60) {
    return ['Z68.44', 'E66.813'] // BMI 60.0-69.9
  } else if (bmi >= 50) {
    return ['Z68.43', 'E66.813'] // BMI 50.0-59.9
  } else if (bmi >= 45) {
    return ['Z68.42', 'E66.813'] // BMI 45.0-49.9
  } else if (bmi >= 40) {
    return ['Z68.41', 'E66.813'] // BMI 40.0-44.9
  } else if (bmi >= 39) {
    return ['Z68.39', 'E66.812'] // BMI 39.0-39.9
  } else if (bmi >= 38) {
    return ['Z68.38', 'E66.812'] // BMI 38.0-38.9
  } else if (bmi >= 37) {
    return ['Z68.37', 'E66.812'] // BMI 37.0-37.9
  } else if (bmi >= 36) {
    return ['Z68.36', 'E66.812'] // BMI 36.0-36.9
  } else if (bmi >= 35) {
    return ['Z68.35', 'E66.812'] // BMI 35.0-35.9
  } else if (bmi >= 34) {
    return ['Z68.34', 'E66.811'] // BMI 34-34.9
  } else if (bmi >= 33) {
    return ['Z68.33', 'E66.811'] // BMI 33-33.9
  } else if (bmi >= 32) {
    return ['Z68.32', 'E66.811'] // BMI 32-32.9
  } else if (bmi >= 31) {
    return ['Z68.31', 'E66.811'] // BMI 31-31.9
  } else if (bmi >= 30) {
    return ['Z68.30', 'E66.811'] // BMI 30-30.9
  } else if (bmi >= 29) {
    return ['Z68.29', 'E66.3'] // BMI 29-29.9
  } else if (bmi >= 28) {
    return ['Z68.28', 'E66.3'] // BMI 28-28.9
  } else if (bmi >= 27) {
    return ['Z68.27', 'E66.3'] // BMI 27-27.9
  } else if (bmi >= 26) {
    return ['Z68.26', 'E66.3'] // BMI 26-26.9
  } else if (bmi >= 25) {
    return ['Z68.25', 'E66.3'] // BMI 25-25.9
  }

  return []
}
